module.exports = __webpack_public_path__ + "static/media/iv_stocks.ab707ffe.svg";